var App = (function () {
  'use strict';

  App.mailTemplates = function( ){
    var $mailTemplatesList = $('.js-mail-templates');

    if(!$mailTemplatesList.length) {
      return;
    }

    $(".be-wrapper").addClass("be-aside");

    var $aside = $(".page-aside");
    var formId = 'form-mail-template';
    var templateEditorId = "template-editor";
    var mailTemplateMethod = $mailTemplatesList.data('method');

    var handleTemplates = function(templates) {
      $.each(templates, function(i)
      {
        var template = templates[i];

        var li = $('<li/>')
          .appendTo($mailTemplatesList)
          .click(function() {
            makeListItemActive($mailTemplatesList, this);
          });

        var editLink = $('<a/>')
          .html(template.name)
          .appendTo(li)
          .click(function() {
            fillForm(formId, template);
          });

          var deleteIcon = $('<i class="icon mdi mdi-delete" style="float: right" data-toggle="modal" data-target="#mod-delete"></i>')
          .appendTo(editLink)
          .click(function() {
            $('#template_id').val(template.id);
          });
      });
    }

    initTemplateEditor(templateEditorId);
    initTemplates(handleTemplates);

    $(".js-reset-template-form").click(function() {
      resetMailTemplateForm(formId);
    });

    function makeListItemActive(list, item) {
      list.find('li').each(function(){
        $(this).removeClass('active');
      });
      $(item).addClass('active');
    }

    function fillForm(formId, template) {
      var form = document.getElementById(formId);
      var formFields = form.elements;
      var templateFieldNames = Object.keys(template);

      if (typeof template.body === "undefined") {
        template.body = {
          html: ''
        };
      }

      templateFieldNames.forEach(function(fieldName) {
        if(fieldName in formFields) {
          formFields[fieldName].value = template[fieldName];
        }
      });

      setTemplateEditorContent(templateEditorId, template.body.html ? template.body.html : template.template);

      var copyButton = formFields["copy_id"];
      copyButton.dataset.copy = template.id;
    }

    function initTemplateEditor(templateEditorId) {
      let len = $('.template-editor__length');
      $('#' + templateEditorId).summernote({
        height: 200,
        onCreateLink : function(originalLink) {
          return originalLink; // return original link
        },
        callbacks: {
          onChange: function (content) {
            if (len.length > 0) {
              len.text(`${content.length} символов кода`)
            }
            
          },
          onKeyup: function (e) {
            var t = e.currentTarget.innerText;
            var h = e.currentTarget.innerHTML;
            if (len.length > 0) {
              len.text(`${h.length} символов кода | ${t.length} символов текста`)
            }
          },
        }
      });
    }

    function setTemplateEditorContent(templateEditorId, content) {
      $('#' + templateEditorId).summernote("code", content);
    }

    function resetMailTemplateForm(formId) {
      var form = document.getElementById(formId);

      form.reset();
      setTemplateEditorContent(templateEditorId, '');
      form.elements["copy_id"].dataset.copy = '';
    }

    function initTemplates(handleTemplates) {
      return $.ajax({
        type: 'GET',
        url: '/json/crm_handler/',
        data: {
          method: mailTemplateMethod ? mailTemplateMethod : 'GetMailTemplates',
        },
        beforeSend: function() {
          enableLoading();
        }
      }).done(function(response) {
        handleTemplates(response);
      }).fail(function(response) {
        $aside.html("Не удалось загрузить шаблоны");
      }).always(function() {
        disableLoading();
      });
    }

    function enableLoading() {
      $('.be-loading').addClass('be-loading-active');
    }

    function disableLoading() {
      $('.be-loading').removeClass('be-loading-active');
    }
  };

  return App;
})(App || {});
